import React, { Fragment, useContext } from "react";
import { Row, Col, FormGroup } from "reactstrap";
import QuetionRadio from "./QuetionRadio";
import { AnswerContext } from "../../Module/AnswerContext";

const QuetionStep: React.FC<any> = (quetion_info) => {
  const { node } = quetion_info.quetion;
  return (
    <Fragment>
      <div className="form-wizard-content mt-2 mb-2 pl-3 pr-3">
        <div className="mb-4 ev_question_box">
          <Col md={4} className="mr-5 ev_question mb-3">
            {node.content}
          </Col>
          <FormGroup>
            <QuetionRadio node={node} />
          </FormGroup>
        </div>
      </div>
    </Fragment>
  );
};

export default QuetionStep;
